import { useQuery } from '@tanstack/react-query';
import ms from 'ms';
import { useNavigate, useParams } from 'react-router-dom';

import { toast } from '@hivebrite/design-system/Toast';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import type { Event } from 'hb-react/shared/apps/Events';
import { dynamicTopicResourcePath } from 'hb-react/shared/apps/Topics/utils';
import { axiosInstance as axios, isCancel } from 'hb-react/shared/utils/axios';

export const useEvent = ({ route }) => {
  const topicContext = useTopicContext();
  const navigate = useNavigate();

  const { eventId } = useParams();

  const adjustedRoute = dynamicTopicResourcePath(
    route(eventId, { format: 'json' }),
    topicContext,
  );

  const adjustedIndexRoute = dynamicTopicResourcePath(
    Routes.events_path(),
    topicContext,
  );

  const { isLoading, data: event } = useQuery({
    queryKey: ['event', eventId, topicContext.topicId],
    queryFn: () =>
      axios
        .get<{ event: Event }>(adjustedRoute, {
          params: {
            topic_id: topicContext.topicId || undefined,
          },
        })
        .then((response) => response.data.event)
        .catch((error) => {
          if (isCancel(error)) {
            return;
          }

          toast.error(
            s__(
              'Event|The event you tried to view does not exist or is not available.',
            ),
          );
          navigate(adjustedIndexRoute);
        }),
    staleTime: ms('5m'),
    refetchOnMount: false,
  });

  return { isLoading, event };
};
